import React, { useEffect, useState } from 'react';
import { Table, Input, TableCaption, Thead, Tbody, Tr, Th, Td, Button, TableContainer, Box, FormControl, FormLabel,useDisclosure } from "@chakra-ui/react";
import axios from 'axios';
import { numberToWords } from '../../utils/numberToWords';
import * as XLSX from 'xlsx'
import MergeDataPrintModal from './mergeBillPrintModal';

const MergeBillData = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [printData, setPrintData] = useState([]);
  const [roomBill,setRoomBill]=useState([]);
  const [foodBill,setFoodBill]=useState([]);
  const [services,setServices]=useState([]);
  const [addService,setAddService]=useState([]);
  const [otherRate,setOtherRate]=useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [roomBook,setRoomBook]=useState([]);
  const customerId = localStorage.getItem('customerId');
 const {isOpen,onOpen,onClose}=useDisclosure();
    const handlePrintModalOpen=()=>{
      onOpen()
    }
  const fetchData = async () => {
    const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getMergeBill/${customerId}`);
    setData(response.data);
    setFilteredData(response.data);
  };
  const fetchRoomBook=async()=>{
    try {
      const response= await axios.get(`https://api.hotel.tdrsoftware.in/api/getRoomBookData/${customerId}`)
    setRoomBook(response.data.room)
    } catch (error) {
      
    }
    
  }
  const RoomBillData = async () => {
    const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getRoomBilldata/${customerId}`);
    setRoomBill(response.data);
    
  };
  const foodBillData = async () => {
    const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getFoodBillData/${customerId}`);
    setFoodBill(response.data); 
    
  };
  // const fetchServiceData=async()=>{
  //   try {
  //     const response=await axios.get(`https://api.hotel.tdrsoftware.in/api/getRoomService/${customerId}`)
  //     setServices(response.data.roomService)
  //     //console.log(response.data.roomService)
  //   } catch (error) {
  //     //toast.error(error.message)
  //   }
  // }
  const fetchMergeBillData=async(registration)=>{
    try {
      const response= await axios.get(`https://api.hotel.tdrsoftware.in/api/getRoomServiceAdd/${customerId}/${registration}`)
    setServices(response.data.addRoomService)
    } catch (error) {
      
    }
    
  }
  
  const fetchAddServiceData=async()=>{
    try {
      const response=await axios.get(`https://api.hotel.tdrsoftware.in/api/getRoomService/${customerId}`)
      setAddService(response.data.roomService)
      //console.log(response.data.roomService)
    } catch (error) {
      //toast.error(error.message)
    }
  }

  const fetchOtherRate=async()=>{
    try {
      const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getOtherRoomRate/${customerId}`)
      setOtherRate(response.data.otherRoomRate)

    } catch (error) {
      //toast.error("Failed to fetch other room rate data");
    }
  }
const fetchData3 = async () => {
    try {
      const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getPrintData/${customerId}`);
      const rooms = response.data;
  
      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(`https://api.hotel.tdrsoftware.in/get-image/${room.image}`, {
              responseType: 'blob', // Assuming image is returned as a blob
            });
  
            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        })
      );
  
      console.log(updatedRooms, 'updatedRooms');
      setPrintData(updatedRooms);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'startDate') {
      setStartDate(value);
    } else if (name === 'endDate') {
      setEndDate(value);
    }
    filterData(searchTerm, name === 'startDate' ? value : startDate, name === 'endDate' ? value : endDate);
  };
  function getFormattedCurrentDate() {
    const now = new Date(); // Get the current date and time
  
    // Format the date as "DD-MM-YYYY"
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-based, so +1
    const year = now.getFullYear();
  
    // Format the time as "HH:MM AM/PM"
    let hours = now.getHours();
    let minutes = String(now.getMinutes()).padStart(2, '0'); // Add leading zero to minutes if needed
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 24-hour time to 12-hour time, adjusting midnight to 12
   const date=`${day}-${month}-${year} `;
   const time=`${hours}:${minutes}${period.toLowerCase()}`;
  
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}${period.toLowerCase()}`;
    
    return [formattedDate,date,time];
  }
  const newDate = getFormattedCurrentDate();

  const filterData = (term, startDate, endDate) => {
    let filtered = data;

    // Filter by search term
    if (term) {
      filtered = filtered.filter(item =>
        item.phoneNo.includes(term) || item.registration.includes(term)
      );
    }

    // Filter by date range
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      filtered = filtered.filter(item => {
        const checkInDate = new Date(item.checkIn);
        const checkOutDate = new Date(item.checkOut);
        return (checkInDate >= start && checkInDate <= end) || (checkOutDate >= start && checkOutDate <= end) || (checkInDate <= start && checkOutDate >= end);
      });
    }

    setFilteredData(filtered);
  };
  useEffect(() => {
    fetchData();
    fetchData3();
    RoomBillData()
    foodBillData()
   // fetchServiceData()
    fetchAddServiceData()
    //fetchMergeBillData()
    fetchOtherRate()
    fetchRoomBook()
  }, [customerId]);
  const exportToExcel = () => {
    // Filter out _id and createdAt fields from the data
    const cleanedData = filteredData.map(({ _id, createdAt, ...rest }) => rest);
  
    // Create a worksheet from the cleaned data
    const worksheet = XLSX.utils.json_to_sheet(cleanedData);
  
    // Capitalize the first letter of each header
    const headers = Object.keys(cleanedData[0] || {});
    headers.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
      worksheet[cellAddress].v = header.charAt(0).toUpperCase() + header.slice(1);
    });
  
    // Calculate totals for cash and online columns
    let totalCash = 0;
    let totalOnline = 0;
    
    cleanedData.forEach((row) => {
      totalCash += parseInt(row.cash) || 0;
      totalOnline += parseInt(row.online) || 0;
    });
  
    // Add the totals row
    const totalRow = {
      cash: totalCash,
      online: totalOnline,
      // Add any other columns you want to include in the totals row
    };
    
    // Append the total row to the worksheet
    XLSX.utils.sheet_add_json(worksheet, [totalRow], { skipHeader: true, origin: -1 });
  
    // Add borders to all cells in the worksheet
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = { c: C, r: R };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
  
        if (!worksheet[cellRef]) continue;
        if (!worksheet[cellRef].s) worksheet[cellRef].s = {};
        
        worksheet[cellRef].s.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      }
    }
  
    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Cash Data');
  
    // Write the workbook to an Excel file
    XLSX.writeFile(workbook, 'MergeBillData.xlsx');
  };
//console.log(services,"services");
  //const filteredRoomBill=roomBill.filter((room) => room.registration === "2025-52278");
  
 
  const handlePrint = (item) => {
    console.log(services,'services')
    const filteredRoomBill = roomBill.filter((room) => String(room.registration) === String(item.registration));
    const filteredBill = foodBill.filter((food) => String(food.registration) === String(item.registration));
    const filteredFoodBill = filteredBill.filter((food) => food.status === true);
    console.log(filteredRoomBill,'filteredRoomBill')
    
    
    const content = `
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif;  margin: 10px; border: 2px solid black; padding: 10px; border-radius: 5px; }
            .grid-container { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 5px; }
            .container1{ display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-top: 5px; }
            .container { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-top: 10px; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #dddddd; text-align: left; padding: 8px; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body>
          <h3 style="text-align: center; color: purple; padding: 3px">Final Bill</h3>
          <div style="display: flex; justify-content: center; align-items: center; gap: 14px; color: purple;margin-bottom:10px">
            ${printData.map((item) => `
              <img src="${item.imageUrl}" style="width: 120px; height: 120px; border-radius: 12px; margin-right: 10px" />
             <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
    <h3 style="font-weight: bold;  margin: 2px 0;">${item.name}</h3>
    <p style="font-size: 12px; margin: 2px 0;">${item.address}</p>
    <p style="font-size: 12px; margin: 2px 0;">Phone: ${item.phoneNo}</p>
    <p style="font-size: 12px; margin: 2px 0;">Website: ${item.website}</p>
    <p style="font-size: 12px; margin: 2px 0;">Email id: ${item.email}</p>
    <p style="font-size: 12px; margin: 2px 0;">Gst No: ${item.gstNo}</p>
</div>

              
            `).join('')}
          </div>
          <div style="border: 2px solid black; padding: 10px; border-radius: 5px;">
          <div class="container1" style="padding: 5px;color: purple;">
            <div style="font-weight: bold;">
            <p>Name:${item.name}</p>
            <p>Address:${filteredRoomBill[0]?.address}</p>
            <p>CheckIn:${item.checkIn}</p>
            <p>Date:${newDate[1]}</p>
            <p>BookingBy:${filteredRoomBill[0]?.bookingBy}</p>
            <p>Company Name:${filteredRoomBill[0]?.companyName}</p>
            </div>
            <div style="font-weight: bold">
            <p>Phone:${item.phoneNo}</p>
            <p>BillNo:${item.billNo}</p>
            <p>CheckOut:${item.checkOut}</p>
            <p>Time:${newDate[2]}</p>
            <p>GstNo:${filteredRoomBill[0]?.gstNo}</p>
            </div>
           
          </div>
          <div style="color:"black"">
            <table>
            <thead>
            <tr>
            <th>Sl No.</th>
            <th>Particulars</th>
            <th>Rate</th>
            <th>Cgst</th>
            <th>Sgst</th>
            </tr>
            <tbody>
            ${filteredRoomBill.map((room)=>`
            <tr>
            <td>1</td>
            <td>Room Charges(${room.roomNo})</td>
            <td>${room.rate}</td>
            <td>${room.cgst}</td>
            <td>${room?.sgst}</td>
            
            </tr>
            `).join('')}
            
            </tbody>
            </thead>
            </table>
           ${filteredFoodBill.length>0?` <table style="margin-top:20px">
            <thead>
            <tr>
            <th>Food Name</th>
            <th>RoomNo</th>
            <th>CGST</th>
            <th>SGST</th>
            <th>Rate</th>
            </tr>
            </thead>
            <tbody>
            ${filteredFoodBill.map((food)=>`
            <tr>
            <td>
            <table>
            <thead>
            <tr>
            <th>
            Name
            </th>
            <th>Quantity</th>
            <th>Rate</th>
            </tr>
            </thead>
            <tbody>
            
            ${food.foodItem.map((item) => `
            <tr>
            <td>${item.name}</td>
            <td>${item.quantity}</td>
            <td>${item.price}</td>
            </tr>
            `).join('')}
            
           

            </tbody>
            </table>
            </td>
            <td>${food.roomNo}</td>
            <td>${food.cgst}</td>
            <td>${food.sgst}</td>
            <td>${food.totalBilling-food.cgst-food.sgst}</td>
            
            
            `).join('')}
            
            
            </tbody>
            </thead>
            </table>`:' '}

${services.length > 0 ? `
  <table style="margin-top: 20px">
    <thead>
      <tr>
        <th>Sl No</th>
        <th>Room Service</th>
        <th>Price</th>
        <th>SGST</th>
        <th>CGST</th>
      </tr>
    </thead>
    <tbody>
      ${services.map((service, index) => `
        <tr>
          <td>${index + 1}</td>
          <td>${service.roomServiceName}</td>
          <td>${service.roomServicePrice}</td>
          <td>${service.gst ? (addService.filter((add) => add.roomServiceName === service.roomServiceName)
            .reduce((acc, b) => acc + (b.roomServicePrice * (b.cgst / 100 || 0)), 0)) : 0}</td>
          <td>${service.gst ? (addService.filter((add) => add.roomServiceName === service.roomServiceName)
            .reduce((acc, b) => acc + (b.roomServicePrice * (b.cgst / 100 || 0)), 0)) : 0}</td>
        </tr>
      `).join('')}
    </tbody>
  </table>
` : ''}


            <div style="width:20%;border:1px solid black;margin-top:10px;padding:5px;font-size:12px;heaight:100px">
            <p>CGST--6%</p>
            <p>SGST--6%</p>
            <p>CGST--2.5%</p>
            <p>SGST--6%</p>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 2px; color: purple">
            ${printData.map((print) => `
              <div style="margin-left: 10px">
                <h3>Bank Details</h3>
                <h4>A/C No: ${print.acNo}</h4>
                <h5>IFSC: ${print.ifsc}</h5>
                <h5>Branch: ${print.branch}</h5>
              </div>
              <div style="margin-right: 10px;border: 1px solid black; padding: 10px; border-radius: 2px;">
                <h3style="background:"gray"">Summary</h3>
                <h4>RoomBill: ${item.roomBill}</h4>
                <h4>FoodBill: ${item.totalBilling}</h4>
                
                <h4>Total Amount: ${item.mergeBill}</h4>
              </div>
            `).join('')}
          </div>
          <h3 style="color: black; margin-left: 10px">Total (INR-In Words): ${numberToWords(parseInt(item.mergeBill))}</h3>
          <div class='container' style="color: purple; margin: 10px">
            ${printData.map((item) => `
              <div>
                <h5>Front Office Signature- </h5>
                <h5>Date- </h5>
              </div>
              <div>
                <h5>Guest Signature- </h5>
                <h5>Date- </h5>
              </div>
            `).join('')}
          </div>
          </div>
          <script>
            window.onload = () => window.print();
          </script>
        </body>
      </html>
    `;

    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.open();
    printWindow.document.write(content);
    printWindow.document.close();
  };



  return (
    <div>
      <Box display='flex' flexDirection='row' justifyContent='space-evenly' alignItems='center' mt={2} mb={5}>
      <Input
      ml={10}
        w='80%'
        type="text"
        placeholder="Search by Phone No or Registration"
        value={searchTerm}
        onChange={handleSearchChange}
         // Adds margin bottom for spacing
      />
      
        <FormControl display='flex' justifyContent='center' alignItems='center'>
          <FormLabel htmlFor="startDate">Start Date</FormLabel>
          <Input
           width='40%'
            id="startDate"
            name="startDate"
            type="date"
            value={startDate}
            onChange={handleDateChange}
          />
        </FormControl>
        <FormControl display='flex' justifyContent='center' alignItems='center'>
          <FormLabel htmlFor="endDate">End Date</FormLabel>
          <Input
          width='40%'
            id="endDate"
            name="endDate"
            type="date"
            value={endDate}
            onChange={handleDateChange}
          />
        </FormControl>
      
      </Box>
      <Button colorScheme="blue" onClick={exportToExcel} p={2} mb={5}>
       Export to Excel File
      </Button>
       <Button colorScheme="blue" onClick={handlePrintModalOpen} ml={2} p={2} mb={5}>
       Print
      </Button>
      <MergeDataPrintModal isOpen={isOpen} customerId={customerId} onOpen={onOpen} onClose={onClose} mergeData={filteredData} />
      <TableContainer width='full'>
        <Table size='sm' variant='striped' colorScheme='teal'>
          <TableCaption>Merge Bill Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Registration</Th>
              <Th>Bill No</Th>
              <Th>Phone No</Th>
              <Th>CheckIn</Th>
              <Th>CheckOut</Th>
              <Th>Room No</Th>
              <Th>FoodBill</Th>
              <Th>RoomBill</Th>
              <Th>Services</Th>
              <Th>Extra Services</Th>
              <Th>Total</Th>
              <Th>CreatedAT</Th>

              <Th>Actions</Th>
              
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((item, index) => (
              <Tr key={index}>
                <Td>{item.name}</Td>
                <Td>{item.registration}</Td>
                <Td>{item.billNo}</Td>
                <Td>{item.phoneNo}</Td>
                <Td>{item.checkIn}</Td>
                <Td>{item.checkOut}</Td>
                <Td>{item.roomNo}</Td>
                <Td>{item.totalBilling}</Td>
                <Td>{item.roomBill}</Td>
                <Td>{item.roomServicePrice}</Td>
                <Td>{item.price}</Td>
                <Td>{item.mergeBill}</Td>
                <Td>{new Date(item.createdAt).toLocaleString('en-GB')}</Td>
                <Td>
                <Button
  colorScheme="blue"
  size="sm"
  onClick={async () => {
    await fetchMergeBillData(item.registration); // Wait for data fetch
    handlePrint(item); // Then print
  }}
>
  Print
</Button>

                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default MergeBillData;
